import React from 'react';
import { NoBroadcastView } from '../no-broadcast-view/no-broadcast-view';
import { useInputContext } from '../use-input-context';
import { DefaultDetailsViewLoader } from './default-details-view-loader';
import { DetailsViewLoaderProps } from './details-view-loader';

export function ProgramDetailsViewLoader({ id, ...rest }: Omit<DetailsViewLoaderProps, 'type'>) {
  const context = useInputContext();

  if (id === 'empty' && context.platformTitleId) {
    return <NoBroadcastView channelId={context.platformTitleId} />;
  }

  return <DefaultDetailsViewLoader id={id} {...rest} />;
}
